import { useScreenSize } from 'src/customHooks/customHooks'
import TimerClock from '../TimerClock'
import { TimerDigitsContainer } from '../styledComponents'

export default function FixedTimer({
  duration,
  timerSeconds,
  minDuration,
  backgroundImg,
  totalIntervals,
  intervalsLeft,
}) {
  const durationToUse = typeof duration === 'number' ? duration : minDuration
  const timeLeft = durationToUse / 1000 - timerSeconds
  const secondsLeft = Math.floor(timeLeft % 60)
  const minutesLeft = Math.floor((timeLeft / 60) % 60)
  const { width } = useScreenSize()

  return (
    <TimerClock
      timerSeconds={timerSeconds}
      topPadding={width > 768 ? '52px' : '16px'}
      backgroundImg={backgroundImg}
      totalIntervals={totalIntervals}
      intervalsLeft={intervalsLeft}
    >
      <TimerDigitsContainer className="small-text">
        -{String(minutesLeft).padStart(2, '0')}:{String(secondsLeft).padStart(2, '0')}
      </TimerDigitsContainer>
    </TimerClock>
  )
}
